import React, { Component } from "react";
import Icon from "../Common/Icon";

export class Product extends Component {
  render() {
    const {
      product,
      priceFrom,
      productDetailsLinkText,
      productPurchaseLinkText,
    } = this.props;
    return (
      <div
        className={
          "grid__column-cards container--white popular-products__border"
        }
      >
        <div className="popular-products__top-band" />

        <div className="popular-products__product-title">
          <h4>{product.Title}</h4>
        </div>

        <div className="popular-products__content">
          <ul className="popular-products__detail-list">
            {product.Subtitle !== "" && (
              <li className="popular-products__text">{product.Subtitle}</li>
            )}
            {product.ProductRegion !== "" && (
              <li className="popular-products__text">
                {product.ProductRegion}
              </li>
            )}
            {product.ProductFeatures !== "" && (
              <li className="popular-products__text">
                {product.ProductFeatures}
              </li>
            )}
            {product.ProductFeatures !== "" && (
              <li className="popular-products__text">
                {product.TypeOfTransportValidity}
              </li>
            )}
          </ul>
        </div>

        <div className="popular-products__price_container">
          <div>
            <span className="popular-products__price-from">
              {priceFrom}&nbsp;&nbsp;
            </span>
            <span className="popular-products__price">€ {product.Price}</span>{" "}
          </div>
        </div>

        <div>
          <hr className="popular-products__hr" />
        </div>

        <div className="popular-products__buttons-container">
          <div className={"popular-products__buttons"}>
            <a
              href={product.ProductMoreInfo}
              className="link link--animation-on-hover popular-products__more-info"
            >
              <span>{productDetailsLinkText}</span>
              <Icon
                iconName="arrow-right"
                className="link__icon link__icon--right"
              />
            </a>
            <a
              href={product.PurchaseButton}
              className="btn btn--lightgrey2 popular-products__order-button"
              onClick={
                product.PurchaseButton.includes("eticket")
                  ? () => {
                      sessionStorage.setItem("eticket-form", "");
                    }
                  : undefined
              }
            >
              <span className="mobile-hide">{productPurchaseLinkText}</span>
              <Icon
                iconName="arrow-right"
                className="link__icon link__icon--right mobile-hide"
              />
              <span className="mobile-only">
                <Icon iconName="mand" className="link__icon" />
              </span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Product;



// WEBPACK FOOTER //
// ./src/components/Products/Product.js